import { createContext, useContext, useState } from 'react';

const AccountPanelContext = createContext();

export function AccountPanelProvider({ children }) {
  const [isOpen, setIsOpen] = useState(false);

  const openPanel = () => {
    setIsOpen(true);
  };

  const closePanel = () => {
    setIsOpen(false);
  };

  return (
    <AccountPanelContext.Provider value={{ isOpen, openPanel, closePanel }}>
      {children}
    </AccountPanelContext.Provider>
  );
}

export function useAccountPanel() {
  const context = useContext(AccountPanelContext);
  if (!context) {
    throw new Error('useAccountPanel must be used within AccountPanelProvider');
  }
  return context;
}
